import { translateMovementTypes } from '@/utils/format/translateMovementTypes'

interface SelectOption {
  label: string
  value: string | string[] | number
}

type MovementTypeKey = keyof typeof translateMovementTypes

const MOVEMENT_TYPE_FILTER_KEYS: MovementTypeKey[] = [
  'SHOPPING',
  'BONUS',
  'EXPIRATION_POINTS',
  'REDEEM_POINTS',
  'REDEEM_FACTORY_VISIT',
  'REDEEM_EXCLUSIVE_EVENT',
  'REVERSAL_POINTS',
  'MANUAL_ADJUSTMENT',
  'CONTRACT_CANCELLATION',
  'PURCHASE_CANCELLED',
  'MISSION_ACCOMPLISHED'
]

const MOVEMENT_TYPE_OPTIONS: SelectOption[] = [
  { label: 'Tipo de movimentação', value: '' },
  ...MOVEMENT_TYPE_FILTER_KEYS.map((key) => ({ label: translateMovementTypes[key], value: key }))
]

const BRAZIL_STATES_OPTIONS: SelectOption[] = [
  { label: 'Localidade', value: '' },
  { label: 'Brasil', value: 'BR' },
  { label: 'Acre', value: 'AC' },
  { label: 'Alagoas', value: 'AL' },
  { label: 'Amapá', value: 'AP' },
  { label: 'Amazonas', value: 'AM' },
  { label: 'Bahia', value: 'BA' },
  { label: 'Ceará', value: 'CE' },
  { label: 'Distrito Federal', value: 'DF' },
  { label: 'Espírito Santo', value: 'ES' },
  { label: 'Goiás', value: 'GO' },
  { label: 'Maranhão', value: 'MA' },
  { label: 'Mato Grosso', value: 'MT' },
  { label: 'Mato Grosso do Sul', value: 'MS' },
  { label: 'Minas Gerais', value: 'MG' },
  { label: 'Pará', value: 'PA' },
  { label: 'Paraíba', value: 'PB' },
  { label: 'Paraná', value: 'PR' },
  { label: 'Pernambuco', value: 'PE' },
  { label: 'Piauí', value: 'PI' },
  { label: 'Rio de Janeiro', value: 'RJ' },
  { label: 'Rio Grande do Norte', value: 'RN' },
  { label: 'Rio Grande do Sul', value: 'RS' },
  { label: 'Rondônia', value: 'RO' },
  { label: 'Roraima', value: 'RR' },
  { label: 'Santa Catarina', value: 'SC' },
  { label: 'São Paulo', value: 'SP' },
  { label: 'Sergipe', value: 'SE' },
  { label: 'Tocantins', value: 'TO' }
]

const CHANNEL_ENTRIES: SelectOption[] = [
  { label: 'Ação de fluxo', value: 'acao-de-fluxo' },
  { label: 'Loja', value: ['loja', 'pdv'] },
  { label: 'E-Commerce', value: 'ecommerce' },
  { label: 'Venda direta', value: 'venda-direta' },
  { label: 'Loja digital', value: 'loja-digital' },
  { label: 'Backoffice', value: ['backoffice-fidelidade', 'crm'] }
]

const buildChannelOptions = (placeholderLabel: string): SelectOption[] => [
  { label: placeholderLabel, value: '' },
  ...CHANNEL_ENTRIES
]

const ORIGIN_CHANNEL_OPTIONS: SelectOption[] = buildChannelOptions('Canal')

interface DateRangeFilterGroup {
  key: string
  title: string
  filters: [{ key: string; type: 'date-range'; label: string }]
}

const buildDateRangeFilterGroup = (key: string, title: string, label: string): DateRangeFilterGroup => ({
  key,
  title,
  filters: [{ key, type: 'date-range', label }]
})

export type { SelectOption, DateRangeFilterGroup }
export {
  BRAZIL_STATES_OPTIONS,
  MOVEMENT_TYPE_OPTIONS,
  ORIGIN_CHANNEL_OPTIONS,
  buildChannelOptions,
  buildDateRangeFilterGroup
}
